
const d3 = require('d3');
const { TRANSLATE_GENERAL_TAG } = require('../consts');

exports.createHeartRateChart = (rawData, width, height, translate) => {
  const { rt_length, hr_values: data } = rawData
  const HEART_RATE_COLOR = '#093e7e';
  const MIN_HEART_RATE = 30
  const MAX_HEART_RATE = 230;
  const Y_AXIS_NUMBERS = [30, 50, 70, 90, 110, 130, 150, 170, 190, 210, 230]
  const TRANSLATE_TAG = 'charts.heart_rate'

  // dinamic y_axis
  // const allHrValues = data.map(d => d.hr)
  // let maxHr = Math.max(...allHrValues);
  // const maxHrCeil10 = Math.ceil(maxHr/10)*10
  // let minHr = Math.min(...allHrValues);
  // const minHrFloor10 = Math.floor(minHr/10)*10
  // const MAX_HEART_RATE = maxHrCeil10;
  // const MIN_HEART_RATE = minHrFloor10;
  // const Y_AXIS_NUMBERS = []
  // for(let a = MIN_HEART_RATE; a <= MAX_HEART_RATE; a = a+5){
  //   Y_AXIS_NUMBERS.push(a)
  // }

  const rtSeconds = rt_length / 256
  const xAxisSpace = 10
  const ticksPadding = 10
  const ticksSize = 10
  let max_x_ticks = 40
  let xAxisTicks;
  let xAxisValues = []
  const niceNumbers = [2, 4, 5, 10, 20]
  let tickValueFormatNum;

  // this loop returning the x_axis_values by nice number and the total ticks less than max_x_ticks
  for (let n = 0; n < niceNumbers.length; n++) {
    const niceNum = niceNumbers[n]
    const tickVal = niceNum / 2 // we are showing value every 2 ticks
    xAxisValues = []
    for (let s = 0; s <= rtSeconds + tickVal; s = s + tickVal) {
      xAxisValues.push(s)
      if (xAxisValues.length > max_x_ticks) {
        tickValueFormatNum = undefined
        break
      }
      tickValueFormatNum = niceNum
    }
    if (tickValueFormatNum) break
  }
  xAxisTicks = xAxisValues.length

  const xAxisRange = xAxisValues[xAxisTicks - 1] * 256
  const x_tick_range = xAxisRange / (xAxisTicks - 1)
  const margin = { top: 70, right: 70, bottom: 60, left: 60 };
  const x = d3
    .scaleTime()
    .domain(
      [1, xAxisRange]
    )
    .range([margin.left - 10, width - margin.right - 5]);

  const y = d3
    .scaleLinear()
    .domain([MIN_HEART_RATE, MAX_HEART_RATE])
    // .nice()
    .range([height - margin.bottom, margin.top]);

  const xAxis = (g) =>
    g
      .attr('transform', `translate(0,${height - margin.bottom + xAxisSpace})`)
      .call(
        d3
          .axisBottom(x)
          .ticks(xAxisTicks)
          .tickValues(
            Array(xAxisTicks)
              .fill(1)
              .map((e, i) => {
                return i * x_tick_range
              })
          )

          .tickFormat((d, i) => {
            return i % 2 === 0 ? (d / 256).toFixed() : ''; //256 is one seccond
          })

          .tickPadding(ticksPadding)
          .tickSize(ticksSize)
          )
          .style("font-size","22px")
          .attr('color', '#000')
      .call((g) =>
        g
          .selectAll('.tick line')
          .clone()
          .attr('stroke-opacity', 0.2)
          .attr('transform', `translate(0,${-height + margin.top + margin.bottom - xAxisSpace})`)
          .attr('y2', height - margin.top - margin.bottom)
      )
  //   .call((g) => g.select('.domain').remove());

  const yAxis_heartRate = (g) =>
    g
      .attr('transform', `translate(${margin.left - 10},0)`)
      .call(
        d3
          .axisLeft(y)
          .tickValues(Y_AXIS_NUMBERS)
          .tickSize(0)
          .tickPadding(10)
      )
      .style("font-size","22px")
      .attr('color', '#000')
      .call((g) =>
        g
          .selectAll('.tick line')
          .clone()
          .attr('stroke-opacity', (d, i) => {
            // if (i === Y_AXIS_NUMBERS.length - 1) return 0 // hide the top line because in this case of values it's not the same size
            return 0.2
          })
          .attr('x2', width - margin.left - margin.right + 5)
      )
      .call((g) => g.select('.domain').remove())

  const yAxis_right = (g) =>
    g
      .attr('transform', `translate(${width - margin.left - 20},0)`)
      .call(
        d3.axisRight(y).tickValues(Y_AXIS_NUMBERS).tickSize(0).tickPadding(10)
      )
      .attr('color', '#000')
      .style("font-size","22px")
      .call((g) => g.select('.domain').remove());

  const heartRateLineGenerate = d3
    .line()
    .defined((d) => d.hr)
    .x((d, i) => {
      return x(d.rt_index)
    })
    .y((d) => {
      return y(d.hr)
    });
  const svg = d3.create('svg').attr('width', width).attr('height', height);


  svg.append('g').call(xAxis); //.selectAll('.tick text'); //.call(wrap, x.bandwidth());

  svg.append('g').call(yAxis_heartRate);
  svg.append('g').call(yAxis_right);
  const yAxisPulseRateLabel = svg
    .append('text')
    .attr('x', margin.left - 40)
    .attr('y', margin.top - 30)
    .style('font-size', '22px')
    .attr('font-weight', '100')
    .text(translate ? translate(`${TRANSLATE_TAG}.title`) : 'Heart Rate (bpm)');


  const xAxisLabelMin = svg
    .append('text')
    .attr('x', 5)
    .attr('y', y(25) + xAxisSpace + ticksSize + ticksPadding)
    .style('font-size', '22px')
    .attr('font-weight', '100')
    .text(translate ? translate(`${TRANSLATE_GENERAL_TAG}.general_words.sec`) : 'sec')

  const heartRateLine = svg
    .append('path')
    .attr('d', heartRateLineGenerate(data))
    .attr('fill', 'none')
    .attr('transform', (d) => `translate(0,0)`)
    .attr('stroke-width', 1)
    .attr('stroke', HEART_RATE_COLOR);

  const xAxisLineGenerate = d3
    .line()
    .x((d, i) => {
      return i + 10
    })
    .y((d) => {
      return y(d) + xAxisSpace
    });
  const xAxisLine = svg
    .append('path')
    .attr('d', xAxisLineGenerate(
      Array(Math.round(width - margin.right + 20))
        .fill(30)))
    .attr('fill', 'none')
    .attr('transform', (d) => `translate(0,0)`)
    .attr('stroke-width', 1.2)
    .attr('stroke', '#000');

  return svg.node();
};